"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var cleanupProps_1 = __importDefault(require("./cleanupProps"));
var refName = '_isInitialRender-ref';
var addIsInitialRender = ad_hok_1.flowMax(ad_hok_1.addRef(refName, 0), ad_hok_1.addProps(function (_a) {
    var _b = refName, ref = _a[_b];
    if (ref.current <= 2) {
        ref.current = ref.current + 1;
    }
    return {};
}), ad_hok_1.addProps(function (_a) {
    var _b = refName, numRenders = _a[_b].current;
    return ({
        isInitialRender: numRenders < 2,
    });
}), cleanupProps_1.default([refName]));
exports.default = addIsInitialRender;
